var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVerticalDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vertical-dots_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".vertical-dots_svg__st0{fill:#444}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "vertical-dots_svg__st0",
    cx: 8,
    cy: 8,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "vertical-dots_svg__st0",
    cx: 8,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "vertical-dots_svg__st0",
    cx: 8,
    cy: 2,
    r: 2
  }))));
}

export default SvgVerticalDots;